import React, { useEffect } from "react";
import styles from "../../pages/JobDetails/Jobdetails.module.css";
import Lozenge from "@atlaskit/lozenge";
import Skeleton from "react-loading-skeleton";
import { jobStatus, jobTypes } from "../../constants/constants";
import {
  errorHandler,
  formatDateJobLog,
  jobTypeBgColor,
  secondsToDhms,
  statusBackColor,
} from "../../helpers/helpers";
import Avatar from "@atlaskit/avatar";
import { useState } from "react";
import { API } from "../../utility/Api";
import { UseToast } from "../context/ToastContext";
import Button from "@atlaskit/button";

const NameWrapper = ({ children }) => (
  <span className={styles.nameWrapperStyles}>{children}</span>
);
const AvatarWrapper = ({ children }) => (
  <div className={styles.avatarWrapperStyles}>{children}</div>
);
const MainJobDetails = ({
  whereAmI,
  refresh,
  jobDetails,
  searchParams,
  setShowFilterModal,
  totalPages,
  jobToGoTo,
  setJobDetails,
}) => {
  const [userName, setUserName] = useState("");
  const [avatar, setAvatar] = useState("");
  const { setMainMessage } = UseToast();
  const [isLoading, setLoading] = useState(false);
  const getUserName = (accountId) => {
    //eslint-disable-next-line
    AP.request(`/rest/api/3/user?accountId=${accountId}`)
      .then((response) => {
        const responsedata = JSON.parse(response.body);
        setUserName(responsedata.displayName);
        setAvatar(Object.values(responsedata.avatarUrls)[1]);
      })
      .catch((e) => setUserName("Not found"));
  };

  const getRestoreJobdetails = async (token) => {
    setLoading(true);
    await API.get(`api/restore_jobdetails?jobId=${jobToGoTo}`, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        getUserName(response.data.restoreJob.initiatorAccountId, token);

        setJobDetails(response.data.restoreJob);
        setLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        setMainMessage({ appearance: "error", text: data.message });
        setLoading(false);
      });
  };
  const getBackupJobdetails = async (token) => {
    setLoading(true);
    await API.get(`api/backup_jobdetails?jobId=${jobToGoTo}`, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        getUserName(response.data.backupJob.initiatorAccountId, token);
        setJobDetails(response.data.backupJob);
        setLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        setMainMessage({ appearance: "error", text: data.message });
        setLoading(false);
      });
  };

  useEffect(() => {
    // eslint-disable-next-line no-undef
    AP.context.getToken(function (token) {
      if (whereAmI === "restore") {
        getRestoreJobdetails(token);
      } else {
        getBackupJobdetails(token);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  return (
    <div className={styles.firstcontentgridcontainer}>
      <div className={styles.infoitem}>
        <div className={styles.infoitemtitle}>JobId </div>
        <div className={styles.infoitemdata}>
          {isLoading ? <Skeleton width={50} /> : jobDetails.id}
        </div>
      </div>
      {whereAmI !== "backup" ? (
        <div className={styles.infoitem}>
          <div className={styles.infoitemtitle}>Filters </div>
          <div className={styles.infoitemdataclickable}>
            <Button
              type="submit"
              onClick={() => {
                setShowFilterModal(true);
              }}
              appearance="subtle"
            >
              Show filters
            </Button>
          </div>
        </div>
      ) : (
        <div className={styles.infoitem}>
          <div className={styles.infoitemtitle}>Tag </div>
          <div className={styles.infoitemdata}>
            {isLoading ? (
              <Skeleton width={50} />
            ) : jobDetails.tag ? (
              jobDetails.tag
            ) : (
              "-"
            )}
          </div>
        </div>
      )}
      <div className={styles.infoitem}>
        <div className={styles.infoitemtitle}>Type </div>
        <div className={styles.infoitemdata}>
          {isLoading ? (
            <Skeleton width={50} />
          ) : jobDetails.type === 0 ? (
            <Lozenge
              style={{
                backgroundColor: jobTypeBgColor(jobTypes[jobDetails.type]),
                color: "#000",
              }}
              isBold
            >
              {jobTypes[jobDetails.type]}
            </Lozenge>
          ) : jobDetails.type === 1 ? (
            <Lozenge
              style={{
                backgroundColor: jobTypeBgColor(jobTypes[jobDetails.type]),
                color: "#000",
              }}
              isBold
            >
              {jobTypes[jobDetails.type]}
            </Lozenge>
          ) : jobDetails.type === 2 ? (
            <Lozenge
              style={{
                backgroundColor: jobTypeBgColor(jobTypes[jobDetails.type]),
                color: "#000",
              }}
              isBold
            >
              {jobTypes[jobDetails.type]}
            </Lozenge>
          ) : (
            "-"
          )}
        </div>
      </div>
      <div className={styles.infoitem}>
        <div className={styles.infoitemtitle}>Status </div>
        <div className={styles.infoitemdata}>
          <Lozenge
            style={{
              backgroundColor: statusBackColor(
                String(jobStatus[jobDetails.status])
              ),
              color: "#000",
            }}
            isBold
          >
            {isLoading ? <Skeleton width={50} /> : jobStatus[jobDetails.status]}
          </Lozenge>
        </div>
      </div>
      <div className={styles.infoitem}>
        <div className={styles.infoitemtitle}>Time Taken </div>
        <div className={styles.infoitemdata}>
          {isLoading ? (
            <Skeleton width={50} />
          ) : jobStatus[jobDetails.status] === "Queued" ||
            jobStatus[jobDetails.status] === "Running" ? (
            <span>
              ETA : ~
              {searchParams.get("appType") === "Backup"
                ? // ba ckup eta

                  secondsToDhms(
                    searchParams.get("type") === "Issues"
                      ? (searchParams.get("totalissue") > 1400
                          ? searchParams.get("totalissue")
                          : 400) * 0.3
                      : 720
                  )
                : // restore eta
                  secondsToDhms(
                    searchParams.get("type") === "Quick" ? 1800 : 1800
                  )}
            </span>
          ) : (
            // successful jobs
            <span>
              {jobDetails.timeTaken === 0
                ? "-"
                : secondsToDhms(jobDetails.timeTaken)}
            </span>
          )}
        </div>
      </div>
      <div className={styles.infoitem}>
        <div className={styles.infoitemtitle}>Start Time (UTC):</div>
        <div className={styles.infoitemdata}>
          {!isLoading ? (
            formatDateJobLog(jobDetails.startTime)
          ) : (
            <Skeleton width={50} />
          )}
        </div>
      </div>
      <div className={styles.infoitem}>
        <div className={styles.infoitemtitle}>End Time (UTC):</div>
        <div className={styles.infoitemdata}>
          {!isLoading ? (
            jobDetails.status === 1 ||
            jobDetails.status === 2 ||
            jobDetails.endTime === null ? (
              "-"
            ) : (
              // running or queued jobs have no end time
              formatDateJobLog(jobDetails.endTime)
            )
          ) : (
            <Skeleton width={50} />
          )}
        </div>
      </div>
      <div className={styles.infoitem}>
        <div className={styles.infoitemtitle}>Initiator :</div>
        <div className={styles.infoitemdata}>
          {isLoading || userName === "" ? (
            <Skeleton width={50} />
          ) : userName === "Not found" ? (
            jobDetails.initiatorAccountId
          ) : (
            <NameWrapper>
              <AvatarWrapper>
                <Avatar src={avatar} name={"USername"} size="small" />
              </AvatarWrapper>
              {userName}
            </NameWrapper>
          )}
        </div>
      </div>
      {jobDetails.type === 0 &&
        whereAmI === "backup" &&
        jobDetails.status !== 1 && (
          <div className={styles.infoitem}>
            <div className={styles.infoitemtitle}>Total Projects </div>
            <div className={styles.infoitemdata}>
              {isLoading ? <Skeleton width={50} /> : totalPages}
            </div>
          </div>
        )}
    </div>
  );
};

export default MainJobDetails;
